import React, { useState } from 'react';
import { Hero, Spacer, Button, PenlySeo, ContentBoxContainer, ContentBoxText, ContentBoxFigure, ArticlesPreviews, PensionVideoContentBox, Testimonials } from 'components';
import { Routes } from 'utils/routes';
import getConfig from 'next/config';
import { mediaQueries, fromTablethoriMediaQuery } from 'utils/MediaQueriesDeprecated';
import { FAQPageJsonLd } from 'next-seo';
import { scrollToPageElement } from 'utils/componentsCommon';

/* MUI */
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useWindowSize } from 'hooks/useWindowSize';

export default function PensionsTjek() {
    const { publicRuntimeConfig } = getConfig();
    // State
    const [showVideoDialog, setShowVideoDialog] = useState(false);
    const [selectedBox, setSelectedBox] = useState(null); // default: none selected
    const size = useWindowSize();


    const toggleVideo = () => {
        setShowVideoDialog(!showVideoDialog);
    };
    const image = { url: '/static/gfx/content/penly-content-10.jpg' };
    const fromTablethori = mediaQueries(fromTablethoriMediaQuery);
    const getHtml = html => ({ __html: html });
    const pensionCheckFAQEntries = [
        {
            questionName: 'Skal jeg skifte pensionsselskab for at få gavn af jeres rådgivning?',
            acceptedAnswerText: `Nej, det behøver du ikke. Vi hjælper dig med at få det bedste ud af det, du allerede har. Mange får mere ud af deres pension
blot ved at optimere opsparingen eller samle pensioner ét sted – uden nødvendigvis at skifte selskab.`,
        },
        {
            questionName: 'Er Penly uvildige – eller samarbejder I med bestemte selskaber?',
            acceptedAnswerText: `Vi er uvildige. Det betyder, at vi ikke tjener penge på at anbefale bestemte selskaber eller produkter. Vores eneste fokus er at
finde den løsning, der passer bedst til dig og din økonomi.`,
        },
        {
            questionName: 'Hvad får jeg helt konkret ud af at tage et PensionsTjek?',
            acceptedAnswerText: `Du får et samlet overblik over dine pensioner og konkrete forslag til forbedringer, der kan gøre en kæmpe forskel for din
pensionsøkonomi.`,
        },
        {
            questionName: 'Hvad hvis jeg har flere pensioner hos forskellige selskaber?',
            acceptedAnswerText: `Det har de fleste – og netop derfor er et PensionsTjek så vigtigt. Vi samler dine pensioner i ét overblik og viser dig, hvor der
kan være penge at spare eller optimere.`,
        },
    ];
    const addParagraphTags = text => `<p>${text.replace('\n', '</p><p>')}</p>`;

    return (
        <>
            <FAQPageJsonLd mainEntity={ pensionCheckFAQEntries } />
            <PenlySeo title={ 'Få overblik over din pension – for private, selvstændige og firmaer' } description={ 'Se hvordan, du kan få mere ud af din pension – uanset om du er privat, selvstændig eller har ansvar for firmapensionen. Se mere.' } image={ image } />
            <Hero full={ true } overlay={ true } figure={ image.url }>
                <section className="title">
                    <h1>
                        OPDAG HVOR MEGET DIN PENSION KAN VOKSE – MED DEN RETTE RÅDGIVNING
                        { /* KOM I GANG MED DIT <span className="color-highlight">PensionsTjek</span> PÅ 5 MINUTTER */ }
                    </h1>
                    <p style={{ maxWidth:'650px' }}>Hos Penly tilbyder vi forskellige typer PensionsTjek – alt afhængigt af hvordan din situation er. Klik dig videre og få det overblik, du har brug for. </p>
                    <Spacer />
                    <div
                        style={{
                            display: 'flex',
                            gap: '1rem',
                            flexDirection: typeof window !== 'undefined' && size.width < 800 ? 'column' : 'row',
                        }}
                    >
                        <Button
                            onClick={ () => {
                                // setSelectedBox('privat');
                                scrollToPageElement('#boxes', undefined,110);
                            } }
                            size="large"
                        >
                            Privat
                        </Button>
                        <Button
                            onClick={ () => {
                                // setSelectedBox('selvstændig');
                                scrollToPageElement('#boxes', undefined,110);
                            } }
                            size="large"
                        >
                            selvstændig
                        </Button>
                        <Button
                            onClick={ () => {
                                // setSelectedBox('firmapension');
                                scrollToPageElement('#boxes', undefined,110);
                            } }
                            size="large"
                        >
                            firmapension
                        </Button>
                    </div>
                </section>
            </Hero>

            <Spacer size="large" />
            <ContentBoxContainer className="mobileflip" id="boxes" style={{ display: 'flex', justifyContent: 'space-between', alignItems:'center' }} >
                <ContentBoxText
                    className={ `background-primary${selectedBox === 'privat' ? ' highlight-shadow' : ''}` }
                    style={{ padding:'2rem',paddingBottom:'4rem', maxWidth:320, marginBottom: '2rem' }}
                >
                    <div className="taenkBadge"></div>
                    <h4>PRIVATPERSONER</h4>
                    <div>
                        <h6 style={{ height: '2rem' }}>Tag et digitalt PensionsTjek</h6>
                        <p style={{ height: '6rem', marginTop: '2rem' }}>
                            For dig, der der sparer op gennem din arbejdsgiver og gerne vil have et uvildigt overblik over dine pensioner og finde forbedringsmuligheder.                        </p>

                        <div style={{ display:'flex', justifyContent:'center', marginTop:40 }}>
                            <Button size="large" style={{  fontSize:14 }} className="center" color="highlight" href={ Routes.PensionCheck.Privat }>Se Mere</Button>
                        </div>
                    </div>
                </ContentBoxText>
                <ContentBoxText
                    className={ `background-primary${selectedBox === 'selvstændig' ? ' highlight-shadow' : ''}` }
                    style={{ padding:'2rem',paddingBottom:'4rem', maxWidth:320, marginBottom: '2rem' }}
                >
                    <h4>SELVSTÆNDIG</h4>
                    <div>
                        <h6 style={{ height: '2rem' }}>Få trygheden tilbage</h6>
                        <p style={{ height: '6rem', marginTop: '2rem' }}>
                            Vi hjælper dig med at få styr på pension og forsikringer, så du kan være tryg - også hvis livet tager en drejning.
                        </p>
                        <div style={{ display:'flex', justifyContent:'center', marginTop:40 }}>
                            <Button size="large" style={{  fontSize:14 }} className="center" color="highlight" href={ Routes.PensionCheck.Independent }>Se Mere</Button>
                        </div>
                    </div>
                </ContentBoxText>
                <ContentBoxText
                    className={ `background-primary${selectedBox === 'firmapension' ? ' highlight-shadow' : ''}` }
                    style={{ padding:'2rem',paddingBottom:'4rem', maxWidth:320, marginBottom: '2rem' }}
                >
                    <h4>FIRMAPENSION</h4>
                    <div>
                        <h6 style={{ height: '2rem' }}>Til dig der tager ansvar for andres pensioner</h6>
                        <p style={{ height: '6rem', marginTop: '2rem' }}>
                            Få hjælp til at vælge eller vurdere en firmapensionsordning, der skaber værdi for både dig og dine ansatte.
                        </p>
                        <div style={{ display:'flex', justifyContent:'center', marginTop:40 }}>
                            <Button size="large" style={{  fontSize:14 }} className="center" color="highlight" href={ Routes.PensionCheck.Firmapension }>Se Mere</Button>
                        </div>
                    </div>
                </ContentBoxText>
            </ContentBoxContainer>

            <Spacer size="large" />
            { fromTablethori && <Spacer /> }

            <PensionVideoContentBox text='Økonomisk overblik skal ikke være for de få – hør hvordan Penly kan hjælpe dig.' videoId={ 'cqsz1TMdOGQ' } thumbnail={ '/static/gfx/content/penly-videothumbnail-ybDLlsaSItA.png' }/>

            <br />
            <br />
            <Spacer size="large" />

            <Testimonials testimonialCount={ 1 } />

            <Spacer size="large" />


            <ContentBoxContainer className="single">
                <ContentBoxText className="noTp">
                    <h2>
                        FAQ
                    </h2>

                    { pensionCheckFAQEntries.map(faqEntry => (
                        <Accordion key={ faqEntry.questionName }>
                            <AccordionSummary expandIcon={ <ExpandMoreIcon /> } aria-controls="panel1a-content" id="panel1a-header">
                                <h4>{ faqEntry.questionName }</h4>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div
                                    dangerouslySetInnerHTML={ getHtml(addParagraphTags(faqEntry.acceptedAnswerText)) }
                                    style={{ width: '100%' }}
                                />
                            </AccordionDetails>
                        </Accordion>
                    )) }
                </ContentBoxText>
            </ContentBoxContainer>

            <article className="center">
                <Button href={ Routes.PensionCheck.Start } size="large">
                    Tag et PensionsTjek
                </Button>
            </article>
        </>
    );
}
